module.exports = __webpack_public_path__ + "img/instagram.a866d3b4.png";